// Chat configuration reader and orchestrator tuning constants.
//
// The Go template injects window.__SHROUD_CHAT_CONFIG__ before this bundle
// loads. Defaults keep the UI usable when the config block is absent (for
// example, when the bundle is loaded outside the landing template).

import type { ChatConfig } from './types.js';

declare global {
  interface Window {
    __SHROUD_CHAT_CONFIG__?: ChatConfig;
  }
}

/** Read chat config injected by the Go template, with sensible defaults. */
export function getConfig(): ChatConfig {
  const cfg = window.__SHROUD_CHAT_CONFIG__;
  return {
    model: cfg?.model ?? '',
    cocoonEnabled: cfg?.cocoonEnabled ?? false,
  };
}

/** Maximum number of agent-loop rounds per user message. */
export const MAX_TOOL_ROUNDS = 5;

/** BM25 score below which a docs_search result is treated as low-confidence. */
export const LOW_CONFIDENCE_THRESHOLD = 3.0;
